import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {
  // 查询首页目录
  [TYPES.CATEGORY.REQUEST](state: IState) {
    state.category.infos = [];
    state.category.loading = true;
  },
  [TYPES.CATEGORY.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    for (const item of data) {
      item.children = JSON.parse(item.Value);
      if (item.children) {
        item.children.sort((a: any, b: any) => a.Sort - b.Sort)
      }

    }
    state.category.loading = false;
    state.category.infos = data;
  },
  [TYPES.CATEGORY.FAILED](state: IState) {
    state.category.loading = false;
  },

  // 产品信息目录
  [TYPES.PRODUCTCATEGORY.REQUEST](state: IState) {
    state.backgroundDoc.infos = [];
    state.backgroundDoc.loading = true;
  },
  [TYPES.PRODUCTCATEGORY.SUCCESS](state: IState, data) {
    const result = data.res;
    state.backgroundDoc.loading = false;
    state.backgroundDoc.data = Vue.set(state.backgroundIdDoc, 'data', result.Data || []);
  },
  [TYPES.PRODUCTCATEGORY.FAILED](state: IState) {
    state.backgroundDoc.loading = false;
  },

  // 产品信息目录BYID
  [TYPES.IDPRODUCTCATEGORY.REQUEST](state: IState) {
    state.backgroundIdDoc.infos = [];
    state.backgroundIdDoc.loading = true;
  },
  [TYPES.IDPRODUCTCATEGORY.SUCCESS](state: IState, data) {
    const result = data.res;
    state.backgroundIdDoc.loading = false;
    state.backgroundIdDoc.data = result.Data || [];
  },
  [TYPES.IDPRODUCTCATEGORY.FAILED](state: IState) {
    state.backgroundIdDoc.loading = false;
  },

  // 设置产品信息目录BYID
  [TYPES.IDPRODUCTCATEGORYMESSAGE.REQUEST](state: IState) {
    state.triggerMessage.infos = [];
    state.triggerMessage.loading = true;
  },
  [TYPES.IDPRODUCTCATEGORYMESSAGE.SUCCESS](state: IState, data) {
    const result = data.res;
    state.triggerMessage.loading = false;
    state.triggerMessage.data = result.Data || [];
  },
  [TYPES.IDPRODUCTCATEGORYMESSAGE.FAILED](state: IState) {
    state.triggerMessage.loading = false;
  },

  // 查询文档目录
  [TYPES.DOCCATALOG.REQUEST](state: IState) {
    state.doccatalog.loading = true;
  },
  [TYPES.DOCCATALOG.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.doccatalog.loading = false;
    state.doccatalog.infos = data;
  },
  [TYPES.DOCCATALOG.FAILED](state: IState) {
    state.doccatalog.infos = [];
    state.doccatalog.loading = false;
  },

  // 查询文档token
  [TYPES.DOC_TOKEN.REQUEST](state: IState) {
    state.docToken.loading = true;
  },
  [TYPES.DOC_TOKEN.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docToken.loading = false;
    state.docToken.result = data;
  },
  [TYPES.DOC_TOKEN.FAILED](state: IState) {
    state.docToken.result = '';
    state.docToken.loading = false;
  },

  // 查询文档服务地址
  [TYPES.DOC_OSSURL.REQUEST](state: IState) {
    state.docUrl.loading = true;
  },
  [TYPES.DOC_OSSURL.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docUrl.loading = false;
    state.docUrl.result = data;
  },
  [TYPES.DOC_OSSURL.FAILED](state: IState) {
    state.docUrl.result = '';
    state.docUrl.loading = false;
  },

  // 查询文档下载地址
  [TYPES.DOC_DOWNLOAD.REQUEST](state: IState) {
    state.docDownload.loading = true;
  },
  [TYPES.DOC_DOWNLOAD.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docDownload.loading = false;
    state.docDownload.result = data;
  },
  [TYPES.DOC_DOWNLOAD.FAILED](state: IState) {
    state.docDownload.result = '';
    state.docDownload.loading = false;
  },

  // 查询文档信息
  [TYPES.DOC_INFO.REQUEST](state: IState) {
    state.docInfo.loading = true;
  },
  [TYPES.DOC_INFO.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docInfo.loading = false;
    state.docInfo.result = data;
  },
  [TYPES.DOC_INFO.FAILED](state: IState) {
    Message({
      message: '暂无此文档',
      type: 'error'
    });
    state.docInfo.result = {};
    state.docInfo.loading = false;
  },

  // 文档点赞
  [TYPES.PRAISE_DOC_META.REQUEST](state: IState) {
    //
  },
  [TYPES.PRAISE_DOC_META.SUCCESS](state: IState, payload) {
    const { result } = state.docInfo;
    state.docInfo.result = {
      ...result,
      IsPraised: 1,
      PraiseCount: result.PraiseCount + 1
    };
    Message({
      message: payload.res.Message,
      type: 'success'
    });
  },
  [TYPES.PRAISE_DOC_META.FAILED](state: IState) {
    //
  },

  // 文档取消点赞
  [TYPES.CANCEL_PRAISE_DOC_META.REQUEST](state: IState) {
    //
  },
  [TYPES.CANCEL_PRAISE_DOC_META.SUCCESS](state: IState, payload) {
    const { result } = state.docInfo;
    state.docInfo.result = {
      ...result,
      IsPraised: 0,
      PraiseCount: result.PraiseCount - 1
    };
    Message({
      message: payload.res.Message,
      type: 'success'
    });
  },
  [TYPES.CANCEL_PRAISE_DOC_META.FAILED](state: IState) {
    //
  },

  // 获取文档首页列表
  [TYPES.DOC_HOMELIST.REQUEST](state: IState) {
    state.docHomelist.loading = true;
    //
  },
  [TYPES.DOC_HOMELIST.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docHomelist.infos = data;
    state.docHomelist.loading = false;
  },
  [TYPES.DOC_HOMELIST.FAILED](state: IState) {
    state.docHomelist.loading = false;
  },

  // 获取文档首页列表
  [TYPES.DOC_HOMELIST_PAR.REQUEST](state: IState) {
    state.docHomelist.loading = true;
    //
  },
  [TYPES.DOC_HOMELIST_PAR.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.docHomelist.infos = data;
    state.docHomelist.loading = false;
  },
  [TYPES.DOC_HOMELIST_PAR.FAILED](state: IState) {
    state.docHomelist.loading = false;
  },

  // 文档已浏览
  [TYPES.DOC_VIEWED.REQUEST](state: IState) {
    //
  },
  [TYPES.DOC_VIEWED.SUCCESS](state: IState, payload) {
    //
  },
  [TYPES.DOC_VIEWED.FAILED](state: IState) {
    //
  },

  // 获取搜索热词
  [TYPES.HOT_WORDS.REQUEST](state: IState) {
    state.hotWords.loading = true;
  },
  [TYPES.HOT_WORDS.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.hotWords.loading = false;
    state.hotWords.infos = data.filter((d: any) => d).slice(0, 5);
  },
  [TYPES.HOT_WORDS.FAILED](state: IState) {
    state.hotWords.infos = [];
    state.hotWords.loading = false;
  },
  // 获取搜索热词
  [TYPES.SYS_LIST.REQUEST](state: IState) {
    state.sysList.loading = true;
  },
  [TYPES.SYS_LIST.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.sysList.loading = false;
    state.sysList.infos = data;
  },
  [TYPES.SYS_LIST.FAILED](state: IState) {
    state.sysList.infos = [];
    state.sysList.loading = false;
  }
};
